import { z } from 'zod'

import { dbEntitySchema, listQueryZodFields } from './system'

export const affiliateSchema = dbEntitySchema.extend({
  name: z.string(),
  user: z.string().optional().nullable(),
  enabled: z.boolean(),
  apiKeys: z.array(z.string()).optional(),
  membershipName: z.string().optional().nullable(),
  membershipPercentage: z.number().optional(),
  membershipCities: z.array(z.string()).optional(),
  membershipVenues: z.array(z.string()).optional(),
})

export const affiliateCreateArgsSchema = z.object({
  name: z.string().min(1),
  userId: z.string().min(1),
})

export const affiliateUpdateByIdArgsSchema = z.object({
  membershipName: z.string().optional(),
  membershipCities: z.array(z.string()).optional(),
  membershipVenues: z.array(z.string()).optional(),
})

export const affiliateListQuerySchema = z.object({
  ...listQueryZodFields,
  search: z.string().optional(),
})

export const affiliatePublicSchema = affiliateSchema.pick({
  id: true,
  name: true,
  membershipName: true,
  membershipCities: true,
  membershipVenues: true,
})
